<template>
  <div class="p-6">
    <h1 class="title bg-success" >Lista de Usuários</h1>

    <table class="table table-sm table-striped">
      <thead>
        <tr class="bg-gray-100 text-left">
          <th class="border px-4 py-2">ID</th>
          <th class="border px-4 py-2">Nome</th>
          <th class="border px-4 py-2">Email</th>
          <th class="border px-4 py-2">Função</th>
          <th class="border px-4 py-2">Empresa</th>
          <th class="border px-4 py-2">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in users" :key="user.id">
          <td class="border px-4 py-2">{{ user.id }}</td>
           <th class="border px-4 py-2">{{ user.name }}</th>
          <td class="border px-4 py-2">{{ user.email }}</td>
          <td class="border px-4 py-2">{{ user.role }}</td>
          <th class="border px-4 py-2">{{ user.company.name }}</th>
          <td class="border px-4 py-2 space-x-2">
            <div class="d-flex gap-1">
              <button @click="editUser(user)" class="btn btn-secondary">Editar</button>
              <button :disabled="onlineUser.id == user.id" @click="deleteUser(user.id)" class="btn btn-danger">Excluir</button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="mb-4 mt-4 flex items-center justify-between">
      <button @click="openCreateModal" class="btn btn-primary">
        Adicionar
      </button>
    </div>

    <ModalContent
      :isModalOpen="isModalOpen"
      :title="modalTitle"
      :isLoading="isSaving"
      width="600px"
      @close="closeModal"
      @send="saveUser"
    >
      <div class="mb-4">
        <label class="block mb-1 font-medium">Email</label>
        <input v-model="form.email" type="email" class="w-100 border px-3 py-2 rounded" />
      </div>
      <div class="mb-4">
        <label class="block mb-1 font-medium">Nome</label>
        <input v-model="form.name" class="w-100 border px-3 py-2 rounded" />
      </div>
      <div class="mb-4">
        <label class="block mb-1 font-medium">Função</label>
        <select v-model="form.role" class="w-100 border px-3 py-2 rounded">
          <option disabled value="">Selecione uma função</option>
          <option value="admin">Admin</option>
          <option value="operator">Operador</option>
        </select>
      </div>
      <div class="mb-4">
        <label class="block mb-1 font-medium">Empresa</label>
        <select v-model="form.company.id" class="w-100 border px-3 py-2 rounded">
          <option disabled value="">Selecione uma empresa</option>
          <option v-for="company in companies" :value="company.id" :key="company.id"> {{ company.name }}</option>
        </select>
      </div>
    </ModalContent>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import ModalContent from '@/components/ModalContent.vue';
  import { CompanyService, userService } from '@/services/backend/ApiService';
  import OnlineUserService from '@/services/OnlineUserService';
  
  const users = ref([]);
  const companies = ref([]);
  const isModalOpen = ref(false);
  const isSaving = ref(false);
  const modalTitle = ref('');
  const editingUser = ref(null);

  const form = ref({
    email: '',
    oid: '',
    name: '',
    role:'',
    company: {}
  });

  const onlineUser = ref(null);
  
  async function fetchData() {
    onlineUser.value = await OnlineUserService.waitForUser();
    users.value = await userService.findAll();
    companies.value = await CompanyService.findAll();
  }
  
  function openCreateModal() {
    modalTitle.value = 'Criar Usuário';
    form.value = { email: '', name: '', company: {} };
    editingUser.value = null;
    isModalOpen.value = true;
  }
  
  function editUser(user) {
    modalTitle.value = 'Editar Usuário';
    form.value = {
      email: user.email,
      name: user.name,
      role: user.role,
      company: { id: user.company.id}
    };
    editingUser.value = user;
    isModalOpen.value = true;
  }
  
  async function saveUser() {
    isSaving.value = true;
    try {
      const body = {
        email: form.value.email,
        name: form.value.name,
        role: form.value.role,
        company: {id: form.value.company.id}
      };
  
      if (editingUser.value) {
        await userService.update(editingUser.value.id, body);
      } else {
        await userService.create(body);
      }
  
      await fetchData();
      closeModal();
    } catch (err) {
      console.error('Erro ao salvar usuário:', err);
    } finally {
      isSaving.value = false;
    }
  }
  
  async function deleteUser(id) {
    if (confirm('Tem certeza que deseja excluir este usuário?')) {
      await userService.delete(id);
      await fetchData();
    }
  }
  
  function closeModal() {
    isModalOpen.value = false;
  }
  
  onMounted(fetchData);
  </script>
  
<style scoped>

</style>
  